import React from "react";
import { Button, Icon, Card } from "antd";
import { useHistory } from "react-router-dom";

export const NotAuthorized: React.FC = () => {
    const browserHistory = useHistory();

    return (
        <div style={styles.container}>
            <Card style={styles.card}>
                <Icon type="stop" style={styles.icon} />
                <h1 style={styles.title}>Acesso Negado</h1>
                <p style={styles.description}>
                    Você não tem permissão para acessar esta página. Se precisar de acesso, entre em contato com o
                    administrador.
                </p>
                <Button type="primary" onClick={() => browserHistory.push("/")}>
                    Voltar ao Início
                </Button>
            </Card>
        </div>
    );
};

// Estilos inline
const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
    } as React.CSSProperties,
    card: {
        textAlign: "center",
        maxWidth: 800,
        padding: 24,
    } as React.CSSProperties,
    icon: {
        fontSize: 48,
        color: "#ff4d4f",
        marginBottom: 16,
    } as React.CSSProperties,
    title: {
        fontSize: 24,
        marginBottom: 8,
    } as React.CSSProperties,
    description: {
        fontSize: 16,
        marginBottom: 16,
        color: "#595959",
    } as React.CSSProperties,
};
